import { render } from "./Organigramme.vue?vue&type=template&id=4e6f79e4&scoped=true"
import script from "./Organigramme.vue?vue&type=script&lang=js"
export * from "./Organigramme.vue?vue&type=script&lang=js"

import "./Organigramme.vue?vue&type=style&index=0&id=4e6f79e4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e6f79e4"]])

export default __exports__